import { ErrorResponse } from './../../../models/error.model';
import { ActivatedRoute } from '@angular/router';
import { ReportsService } from './../../../services/reports.service';
import { Category } from './../../generics/data-printer/data-printer.component';
import { UtilsService } from './../../../services/utils.service';
import { Component, OnInit } from '@angular/core';
import { getTenantName, getTenantPerson, generateTenantCategories } from 'src/app/models/tenant.model';

@Component({
    selector: 'app-report-details',
    templateUrl: './report-details.component.html',
    styleUrls: ['./report-details.component.scss']
})
export class ReportDetailsComponent implements OnInit {

    categories: Category[] = [];

    constructor(
        private utilsService: UtilsService,
        private reportsService: ReportsService,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params.id) {
                this.reportsService.getReportById(params.id).subscribe(report => {
                    this.categories = [
                        {
                            name: 'Información general', items: [
                                { label: 'Fecha', value: report.fechaCreacion, type: 'datetime' },
                                { label: 'Dictamen de grupo', value: report.dictamen },
                                { label: 'Usuario solicitante', value: report.emailSolicitante },
                            ]
                        },

                    ];

                    if (report.montoAlquilerGrupo != null) {
                        this.categories[0].items.push(
                            { label: 'Alquiler + Expensas sugerido del Grupo', value: report.montoAlquilerGrupo, type: 'money' },
                        );
                    }

                    if (report.error) {
                        this.categories[0].items.push({ label: 'Error', value: report.error });
                    }

                    if (report.aprobacionManual) {
                        this.categories[0].items.push(
                            { label: 'Fecha aprobación manual', value: report.aprobacionManual, type: 'datetime' },
                            { label: 'Motivo aprobación manual', value: report.razonAprobacionManual },
                        );
                    }

                    report.ejecuciones.forEach((execution, index) => {
                        const execCategory = {
                            name: 'Ejecución ' + (index + 1), items: [
                                { label: 'Estado', value: execution.status },
                                { label: 'Alquiler + Expensas sugerido', value: execution.montoAlquiler },
                                { label: 'Mensaje', value: execution.mensajeOutput },
                                { label: 'Dictamen Motor', value: execution.dictamen },

                            ]
                        };
                        this.categories.push(execCategory);

                        // Agregar datos de persona si están disponibles
                        if (execution.persona) {
                            const personaCategory = {
                                name: 'Datos Personales Inquilino', items: [
                                    { label: 'Apellido y Nombre', value: execution.persona.ape_nom },
                                    { label: 'Sexo', value: execution.persona.sexo },
                                    { label: 'Número de Documento', value: execution.persona.nume_docu },
                                    { label: 'CUIL/CUIT', value: execution.persona.cdi },                                    
                                    { label: 'Fecha de Nacimiento', value: execution.persona.fecha_nacimiento },
                                    { label: 'Tipo de Documento', value: execution.persona.t_docu },
                                    { label: 'Edad', value: execution.persona.edad },
                                    { label: 'Fallecido', value: execution.persona.fallecido },
                                    { label: 'Dirección', value: execution.persona.direc_calle },
                                    { label: 'Localidad', value: execution.persona.localidad },
                                    { label: 'Provincia', value: execution.persona.provincia },
                                    { label: 'Código Postal', value: execution.persona.codigo_postal },
                                    { label: 'Apellido Materno', value: execution.persona.apellido_materno },
                                ]
                            };
                            this.categories.push(personaCategory);
                        }

                        const explicaciones = { name: 'Ejecución ' + (index + 1) + ' - Explicación', items: [] };
                        for (const key in execution.explicacion) {
                            const value = execution.explicacion[key];
                            explicaciones.items.push({ label: key, value });
                        }
                        this.categories.push(explicaciones);

                    });



                }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener reporte', error.error?.descripcion));

            }
        });
    }

}
